document.addEventListener('click', function (e) {
  const prevButton = e.target.closest('.card-gallery-arrows__arrow-prev');
  const nextButton = e.target.closest('.card-gallery-arrows__arrow-next');

  if (!prevButton && !nextButton) return;

  const card = e.target.closest('.card-wrapper-new');
  if (!card) return;

  const mediaContainer = card.querySelector('.media');
  if (!mediaContainer) return;

  const scrollAmount = mediaContainer.clientWidth;

  mediaContainer.querySelectorAll('img').forEach((img) => {
    img.style.width = 'auto';
  });

  if (prevButton) {
    mediaContainer.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth',
    });
  }

  if (nextButton) {
    mediaContainer.scrollBy({
      left: scrollAmount,
      behavior: 'smooth',
    });
  }

  manualNavigationTime.set(card, Date.now());

  // Load images that will be visible after scrolling
  setTimeout(() => {
    loadVisibleImages(mediaContainer);
  }, 100);

  mediaContainer.querySelector('img')?.addEventListener('click', () => {
    const images = mediaContainer.querySelectorAll('img');

    if (!images || !images.length) return; // Exit early if no images

    images.forEach((img) => {
      if (img.complete && img.naturalWidth !== 0) {
        img.style.width = 'auto';
      } else {
        // If image not fully loaded, wait for it to load
        img.addEventListener('load', function onLoad() {
          img.style.width = 'auto';
          img.removeEventListener('load', onLoad); // Clean up
        });
      }
    });
  });
});

let observer;
const timers = new WeakMap();
const manualNavigationTime = new WeakMap();

// Load a single lazy image
function loadLazyImage(img) {
  if (img.dataset.src) {
    img.src = img.dataset.src;
    img.removeAttribute('data-src');
  }
  if (img.dataset.srcset) {
    img.srcset = img.dataset.srcset;
    img.removeAttribute('data-srcset');
  }
}

// Scroll to the next image (one image width)
function scrollToNextImage(card) {
  const mediaContainer = card.querySelector('.media');
  if (!mediaContainer) return;

  const images = mediaContainer.querySelectorAll('img');
  if (images.length < 2) return; // Need at least 2 images to scroll

  const containerWidth = mediaContainer.clientWidth;
  const currentScrollLeft = mediaContainer.scrollLeft;

  // Scroll to the next image (one image width)
  const targetScroll = currentScrollLeft + containerWidth;

  // Only scroll if we're not already at the end
  if (targetScroll < mediaContainer.scrollWidth) {
    mediaContainer.scrollTo({
      left: targetScroll,
      behavior: 'smooth'
    });
  }
}

// Load images that are currently visible or about to be visible
function loadVisibleImages(mediaContainer) {
  if (!mediaContainer) return;

  const images = Array.from(mediaContainer.querySelectorAll('img'));
  const containerWidth = mediaContainer.clientWidth;
  const scrollLeft = mediaContainer.scrollLeft;

  images.forEach((img, index) => {
    // Skip if image is already loaded
    if (!img.dataset.src && !img.dataset.srcset) return;

    // Calculate approximate position (each image is container width)
    const imgLeft = index * containerWidth;
    const imgRight = imgLeft + containerWidth;

    // Load image if it's visible or within 2 container widths (preload next/prev)
    if (imgRight >= scrollLeft - containerWidth * 2 && imgLeft <= scrollLeft + containerWidth * 3) {
      loadLazyImage(img);
    }
  });
}

function loadCardImages(card) {
  const elements = card.querySelectorAll('[data-src], [data-srcset]');
  elements.forEach(el => {
    if (el.dataset.src) {
      el.src = el.dataset.src;
      el.removeAttribute('data-src');
    }
    if (el.dataset.srcset) {
      el.srcset = el.dataset.srcset;
      el.removeAttribute('data-srcset');
    }
  })
}



function getAllCards() {
  const cards = document.querySelectorAll('.card-wrapper-new');
  cards.forEach(card => {
    const handleHover = () => {
      const showSecondary = card.dataset.showSecondaryImage === 'true';
      if (!showSecondary) return;
      
      const mediaContainer = card.querySelector('.media');
      if (!mediaContainer) return;

      const images = mediaContainer.querySelectorAll('img');
      if (images.length < 2) return; // Need at least 2 images

      // Check if we're at the start (showing first image)
      const isAtStart = mediaContainer.scrollLeft <= 1;

      const lastManualNav = manualNavigationTime.get(card);
      const timeSinceManualNav = lastManualNav ? Date.now() - lastManualNav : Infinity;

      // Skip auto-scroll if manual navigation happened within last 1500ms      
      if (timeSinceManualNav < 1500) {
        return;
      }

      if (isAtStart) {
        // We're showing the first image, scroll to the second image
        // First, ensure image 2 is loaded if it's lazy
        const secondImage = images[1];
        if (secondImage.dataset.src || secondImage.dataset.srcset) {
          loadLazyImage(secondImage);
          // Wait for image to load before scrolling to prevent layout jump
          if (!secondImage.complete) {
            secondImage.addEventListener('load', () => {
              scrollToNextImage(card);
            }, { once: true });
            return;
          }
        }
        // Image 2 is already loaded, scroll to it
        scrollToNextImage(card);
      }
      // If not at start, do nothing (user is already viewing a different image)
    };

    card.addEventListener('mouseover', handleHover);
    card.addEventListener('touchstart', handleHover);
    
    // Set up scroll listener to load images as they come into view
    const mediaContainer = card.querySelector('.media');
    if (mediaContainer) {
      const handleScroll = () => {
        loadVisibleImages(mediaContainer);
      };
      mediaContainer.addEventListener('scroll', handleScroll, { passive: true });
      
      // Load initially visible images
      loadVisibleImages(mediaContainer);
    }
  });
}

window.addEventListener('load', getAllCards);

function resizeWrapper(media) {
  const images = media.querySelectorAll('img');
  if (images.length > 0) {
    const containerWidth = media.clientWidth;

    images.forEach(img => {
      if (img.style.width !== `${containerWidth}px`) {
        img.style.width = `${containerWidth}px`;
      }
    });

    //media.scrollLeft = 0; // align start
    media.dataset.resized = "true";
  }
}

function initObserver() {
  if (observer) return observer; // reuse same one

  observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      const media = entry.target;

      if (entry.isIntersecting && !media.dataset.resized) {
        if (!timers.has(media)) {
          const timerId = setTimeout(() => {
            resizeWrapper(media);
            obs.unobserve(media);
            timers.delete(media);
          }, 200);

          timers.set(media, timerId);
        }
      } else {
        if (timers.has(media)) {
          clearTimeout(timers.get(media));
          timers.delete(media);
        }
      }
    });
  }, { threshold: 0.3 });

  return observer;
}

function observeMediaElements() {
  const obs = initObserver();
  document.querySelectorAll('.media').forEach(media => {
    if (!media.dataset.observing) {
      obs.observe(media);
      media.dataset.observing = "true";
    }
  });
}

// ---- Bootstrapping ----
const productGridContainer = document.querySelector('.product-grid-container');
if (productGridContainer) {
  window.addEventListener('load', observeMediaElements);
}

// ---- Hook into "load more" ----
document.addEventListener('load-more-done', () => {
  if (productGridContainer) {
    observeMediaElements(); // observe new items too
    getAllCards();
  }
  buttonOpacity();
});


function buttonOpacity() {
  const allCards = document.querySelectorAll('.card-wrapper-new');

  allCards.forEach(card => {
    const mediaContainer = card.querySelector('.media');
    const prevButton = card.querySelector('.card-gallery-arrows__arrow-prev');
    const nextButton = card.querySelector('.card-gallery-arrows__arrow-next');

    if (!mediaContainer) return;

    const updateButtonState = () => {
      const scrollLeft = mediaContainer.scrollLeft;
      const scrollWidth = mediaContainer.scrollWidth;
      const containerWidth = mediaContainer.clientWidth;

      const atStart = scrollLeft <= 0;
      const atEnd = scrollLeft + containerWidth >= scrollWidth - 1; // small buffer


      prevButton.classList.toggle('card-gallery-arrows__arrow--disabled', atStart);

      if (atStart) {
        if (atEnd) {
          nextButton.classList.remove('card-gallery-arrows__arrow--disabled');
        } else {
          nextButton.classList.remove('card-gallery-arrows__arrow--disabled');
        }
      } else {
        if (atEnd) {
          nextButton.classList.add('card-gallery-arrows__arrow--disabled');
        } else {
          nextButton.classList.remove('card-gallery-arrows__arrow--disabled');
        }
      }
    };

    // Set initial state
    updateButtonState();

    // Update on scroll
    mediaContainer.addEventListener('scroll', updateButtonState);
  });
}


